import React from 'react';
import { CloseOutlined, WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner, BaseButton } from '@components';
import { AbsoluteWrapper as Wrapper } from '@components/alert-banner/styled.tsx';
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks.ts';
import { useQuestionsCsv } from '@hooks/useQuestionsCsv.ts';
import { Trans, useLingui } from '@lingui/react/macro';
import { clearQuestionsCsvImportState } from '@routes/sidebar/admin-center/creator/___pages___/elements/model/creatorElementsSlice.ts';
import { isEmpty } from 'lodash';

interface Props {
    recordsUploaded: number;
    recordsRejected: number;
    filename: string;
}

export const QuestionsCsvImportWithErrorsBanner: React.FC<Props> = ({ recordsUploaded, recordsRejected, filename }) => {
    const { t } = useLingui();
    const dispatch = useAppDispatch();
    const { downloadQuestionsCsvIssues } = useQuestionsCsv();
    const questionsCsvIssuesFileContent = useAppSelector(
        (state) => state.adminCenterCreatorElements.questionsCsvIssuesFileContent,
    );

    const handleClose = () => {
        dispatch(clearQuestionsCsvImportState());
    };

    return (
        <Wrapper $width={'40%'}>
            <BaseAlertBanner
                closable={{
                    onClose: handleClose,
                    closeIcon: <CloseOutlined />,
                }}
                type="warning"
                title={filename}
                description={
                    <>
                        <Trans>
                            {recordsUploaded} records uploaded successfully, {recordsRejected} records with error(s)
                            rejected
                        </Trans>
                        {!isEmpty(questionsCsvIssuesFileContent) && (
                            <div style={{ marginTop: 12 }}>
                                <BaseButton onClick={downloadQuestionsCsvIssues} $customType={'link'}>
                                    {t`Download file with errors`}
                                </BaseButton>
                            </div>
                        )}
                    </>
                }
                icon={<WarningFilled />}
            />
        </Wrapper>
    );
};
